import {useQuery} from 'react-query'
import {Link} from 'react-router-dom'
import {useAuth} from '../app/modules/auth'
import {getMfaStatus} from '../app/modules/auth/core/mfaApi'

export function MfaGracePeriodBanner() {
  const {auth, currentUser} = useAuth()
  const {data} = useQuery(['mfa-status'], () => getMfaStatus(), {
    enabled: !!auth?.token,
    refetchOnWindowFocus: true,
    staleTime: 60000,
  })

  const status = data?.data
  if (!status?.showGracePeriodBanner) return null

  const profileCode = currentUser?.result?.code

  return (
    <div
      className='d-flex align-items-center justify-content-between px-6 py-3'
      style={{backgroundColor: '#FFF8E1', borderBottom: '1px solid #FFE082'}}
    >
      <div className='d-flex align-items-center gap-3'>
        <i className='bi bi-hourglass-split fs-4' style={{color: '#F9A825'}} />
        <span className='text-gray-800'>
          MFA setup is optional for the next <strong>{status.daysRemaining ?? 0} days</strong>. After that, you will be
          required to complete setup the next time you sign in.
        </span>
      </div>
      {profileCode && (
        <Link to={`/profile/${profileCode}?mfa=1`} style={{color: '#D7383C', fontWeight: 600, whiteSpace: 'nowrap'}}>
          Set up now
        </Link>
      )}
    </div>
  )
}
